import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "printer",
  "use": "printer-usage",
  "viewBox": "0 0 29 28",
  "content": "<symbol viewBox=\"0 0 29 28\" xmlns=\"http://www.w3.org/2000/svg\" id=\"printer\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M18.355 13.116h6.591V10.48h-6.59v2.636z\" fill=\"currentColor\" /><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.899 0v6.558H0v16.049h5.899v4.91h17.037v-4.91h5.9V6.557h-5.867V0H5.9zm2.636 6.558h11.798V2.636H8.535v3.922zM2.636 9.194h23.596v10.81h-3.263V17.07H5.9v-.032 2.933H2.636V9.194zm5.9 15.72h11.797v-5.24H8.535v5.24z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id